import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, Newspaper, Mail, Lock } from "lucide-react";
import { SEMPLIFICAPP_URL } from "@/data/content";

export default function NotFound() {
  useEffect(() => {
    document.title = "Pagina non trovata — Semplificaffitto.it";
  }, []);
  return (
    <main className="min-h-screen bg-ink text-white flex items-center justify-center px-5 relative overflow-hidden" data-testid="not-found-page">
      <div className="absolute inset-0 opacity-40 bg-[radial-gradient(ellipse_at_top_right,#1B4268_0%,transparent_55%)]" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative text-center max-w-lg"
      >
        <img src="/assets/logo-nuovo.png" alt="Semplificaffitto.it" className="h-8 w-auto brightness-0 invert mx-auto mb-10" />
        <p className="font-serif font-bold text-[7rem] sm:text-[9rem] leading-none text-azure/90">404</p>
        <h1 className="font-serif font-bold text-3xl sm:text-4xl mt-2">Questa pagina è sfitita.</h1>
        <p className="mt-4 text-white/60 leading-relaxed">
          L'indirizzo che cercavi non esiste o è stato spostato. Nessun problema:
          torna alla home o esplora le guide del blog.
        </p>
        <div className="mt-9 flex flex-wrap justify-center gap-3">
          <Link to="/" data-testid="notfound-home-btn" className="inline-flex items-center gap-2 bg-gold text-ink font-semibold rounded-full px-6 py-3.5 text-sm hover:bg-white transition-colors duration-300">
            <Home size={16} /> Torna alla home
          </Link>
          <Link to="/" onClick={() => sessionStorage.setItem("scrollTo", "#blog")} data-testid="notfound-blog-btn" className="inline-flex items-center gap-2 border border-white/25 rounded-full px-6 py-3.5 text-sm hover:bg-white/10 transition-colors duration-300">
            <Newspaper size={16} /> Vai al blog
          </Link>
          <a href={SEMPLIFICAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="notfound-reserved-btn" className="inline-flex items-center gap-2 border border-white/25 rounded-full px-6 py-3.5 text-sm hover:bg-white/10 transition-colors duration-300">
            <Lock size={14} /> Area Riservata
          </a>
        </div>
        <p className="mt-10 text-xs text-white/35">
          Serve aiuto? <a href="mailto:info@semplificaffitto.it" className="text-azure hover:underline">info@semplificaffitto.it</a> · 055 0317244
        </p>
      </motion.div>
    </main>
  );
}
